//#region src/service-provider/service-provider-model.ts
var SC_INVALID_USER = -150;
var SC_TECHNICAL_FAILURE = -180;
var BusinessError = class extends Error {
	/**
	* Comment,
	*
	* @param {string} message - The event detail object to be synced.
	* @param {number} code - The event detail object to be synced.
	*/
	constructor(message, code = SC_TECHNICAL_FAILURE) {
		super(message);
		this.code = code;
		Object.setPrototypeOf(this, new.target.prototype);
	}
};
//#endregion
export { BusinessError, SC_INVALID_USER, SC_TECHNICAL_FAILURE };
